import reduxApi from 'redux-api';
import customFetch from 'api/axios';
import { API_URL } from 'constants/config';


export default reduxApi({
  getGiaiQuyetDon: {
    url: `${API_URL}/danhSachGiaiQuyetDons`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLichSuGiaiQuyetDon: {
    url: `${API_URL}/giaiQuyetDons/thongTinGiaiQuyetDon`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuanTheoDoiEnumn: {
    url: `${API_URL}/giaiQuyetDon/donViTheoDoi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getPhongBanThuocCoQuan: {
    url: `${API_URL}/coQuanQuanLys/phongBanKhacPhongBanHienTaiTheoDonVi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getNgayHetHanLapDuThao: {
    url: `${API_URL}/dons/ngayMacDinhThoiHanGiaoLapDuThao`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getKetQuaGiaiQuyetDon: {
    url: `${API_URL}/ketQuaGiaiQuyetTheoDons?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuanTheoDoi: {
    url: `${API_URL}/coQuanQuanLys/donViTheoDois`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getNguonDon: {
    url: `${API_URL}/nguonTiepNhanDons`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiDonThu: {
    url: `${API_URL}/loaiDonThus`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    },
  },
  getHuongXuLy: {
    url: `${API_URL}/huongXuLys`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCurrentForm: {
    url: `${API_URL}/currentForm`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCongChuc: {
    url: `${API_URL}/congChucs/vaiTro?`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCongChucByEmail: {
    url: `${API_URL}/congChucs/by-email`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getListDonViNhanTDTH: {
    url: `${API_URL}/coQuanQuanLys/donViNhanTGTHs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getDonViNhanTDTH: {
    url: `${API_URL}/coQuanQuanLys/donViDuocPhepNhanTheoDoiThucHiens`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getListPhongBanNhanTDTH: {
    url: `${API_URL}/coQuanQuanLys/tatCaPhongBanNhanTGTHs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getPhongBanNhanTDTH: {
    url: `${API_URL}/coQuanQuanLys/phongBanThanhTraNhanTGTHs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViTTXM: {
    url: `${API_URL}/coQuanQuanLys/donViChuTris`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getThongTinGiaiQuyetDon: {
    url: `${API_URL}/thongTinGiaiQuyetDons/:id`,
    options: (url, params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getTinhTrangGiaiQuyet: {
    url: `${API_URL}/tinhTrangGiaiQuyets`,
    options: (url, params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  postGiaiQuyetDon: {
    url: `${API_URL}/giaiQuyetDons`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postTaiLieuDinhKem: {
    url: `${API_URL}/taiLieuVanThus/multi`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  updateTaiLieuDinhKem: {
    url: `${API_URL}/taiLieuVanThus/multi`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  deleteTaiLieuDinhKem: {
    url: `${API_URL}/taiLieuVanThus/multi`,
    options: (url, params, getState) => {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  postTaiLieuDinhKemDon: {
    url: `${API_URL}/taiLieuVanThus`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  tuGiaiQuyetDon: {
    url: `${API_URL}/giaiQuyetDons/tuXuLy`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateTaiLieuDinhKemDon: {
    url: `${API_URL}/taiLieuVanThus/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  deleteTaiLieuDinhKemDon: {
    url: `${API_URL}/taiLieuVanThus/:id`,
    options: (url, params, getState) => {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  getTaiLieuDinhKemDon: {
    url: `${API_URL}/taiLieuVanThus`,
    options: (url, params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  updateGiaiQuyetDon: {
    url: `${API_URL}/thongTinGiaiQuyetDons/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  dinhChiGiaiQuyetDon : {
    url : `${API_URL}/giaiQuyetDons/:id/dinhChi`,
    options: (url, params, getState) => {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  inPhieuGiaoNhiemVuXacMinhKhieuNai : {
    url : `${API_URL}/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhKhieuNai`,
    options: (url, params, getState) => {
      return {
        method: 'GET',
        data: params
      };
    }
  },
  inPhieuGiaoNhiemVuXacMinhToCao : {
    url : `${API_URL}/giaiQuyetDons/inPhieuGiaoNhiemVuXacMinhToCao`,
    options: (url, params, getState) => {
      return {
        method: 'GET',
        data: params
      };
    }
  },
  getListTheoDoiThucHienGQD : {
    url : `${API_URL}/theoDoiThucHiens`,
    options: (url, params, getState) => {
      return {
        method: 'GET',
        data: params
      };
    }
  },
  getListDonDaGiaiQuyet : {
    url : `${API_URL}/donDaGiaiQuyets`,
    options: (url, params, getState) => {
      return {
        method: 'GET',
        data: params
      };
    }
  },
  getListNguoiBanHanh : {
    url : `${API_URL}/congChucs/nguoiBanHanhs`,
    options: (url, params, getState) => {
      return {
        method: 'GET',
        data: params
      };
    }
  },
  getListNguoiBanHanhKTTT : {
    url : `${API_URL}/congChucs/nguoiBanHanhs/cuocThanhTra`,
    options: (url, params, getState) => {
      return {
        method: 'GET',
        data: params
      };
    }
  },
}).use('fetch', customFetch);



// WEBPACK FOOTER //
// ./src/api/giaiQuyetDonThu.js